import clsx from 'clsx'
import {
  type ChangeEventHandler,
  type ForwardedRef,
  forwardRef,
  type ReactNode,
} from 'react'

export type YesNoToggleProps = {
  checked?: boolean
  className?: string
  disabled?: boolean
  onOff?: boolean
  condensed?: boolean
  name: string
  label?: ReactNode
  onChange?: ChangeEventHandler<HTMLInputElement>
}

const YesNoToggle = forwardRef(
  (
    {
      checked,
      className,
      disabled,
      name,
      label,
      onOff,
      condensed,
      onChange,
    }: YesNoToggleProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    // Determine content values based on props
    const getContentValues = () => {
      if (condensed) {
        return { unchecked: '', checked: '' }
      }
      if (onOff) {
        return { unchecked: 'OFF', checked: 'ON' }
      }
      return { unchecked: 'NO', checked: 'YES' }
    }

    const { unchecked, checked: checkedContent } = getContentValues()

    return (
      <>
        {label && (
          <label className="mr-2" htmlFor={name}>
            {label}
          </label>
        )}
        <div>
          <input
            ref={ref}
            checked={checked}
            disabled={disabled}
            id={name}
            name={name}
            onChange={onChange}
            type="checkbox"
            className={clsx('peer absolute opacity-0')}
          />

          <label
            htmlFor={name}
            style={
              {
                '--content-unchecked': `"${unchecked}"`,
                '--content-checked': `"${checkedContent}"`,
              } as React.CSSProperties
            }
            className={clsx(
              className,
              'shrink-0 relative before:transition-all before:duration-200 before:border-2 before:border-fv-blue-300 before:w-7 before:h-7 before:rounded-full before:bg-fv-blue-100 before:z-[5] before:absolute peer-checked:before:bg-white peer-checked:before:border-fv-blue-400 peer-checked:before:right-[-2px] before:right-[calc(100%-1.75rem+2px)] before:top-1/2 before:-translate-y-1/2  before:text-[.65rem]  before:flex before:items-center before:justify-center before:font-bold peer-checked:bg-fv-blue peer-focus-visible:before:border-fv-orange-bright peer-focus-visible:before:bg-fv-orange-25 bg-white flex items-center h-5 min-w-12 rounded-full border-2 border-fv-blue-200 transition-all duration-500',
              disabled ? 'cursor-not-allowed opacity-75' : 'cursor-pointer',
              'before:content-[var(--content-unchecked)] peer-checked:before:content-[var(--content-checked)]',
            )}
          />
        </div>
      </>
    )
  },
)

export default YesNoToggle
